/**
 * A capture of the real screen, or nothing. A mockup of a product view that
 * does not look like that is worse than an empty fold, because the first thing
 * a buyer does after signing up is compare them.
 */
const SHOT: string | null = null;

/**
 * The after-state, directly below the hero: what the product actually produces,
 * captioned with the outcome rather than the feature name.
 */
export function ProductShot() {
  if (!SHOT) return null;
  return (
    <section className="section">
      <div className="container">
        <figure style={{ margin: 0 }}>
          <img
            src={SHOT}
            alt="Proposal AI compliance matrix: every solicitation requirement listed with its section reference, the response section that answers it, and its coverage state, so an unanswered requirement is visible before submission."
            width={1600}
            height={1000}
            loading="lazy"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "var(--ods-radius-lg)",
              border: "1px solid var(--ods-color-border)",
            }}
          />
          <figcaption style={{ color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)", marginTop: "var(--ods-space-3)" }}>
            Proposal AI turns a solicitation into a requirement by requirement compliance matrix, so you can see what is
            still unanswered before the deadline instead of after the debrief.
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
